import Button from "shared/Button";
import Card from "shared/Card";
import styles from "./index.module.css";
import classNames from "classnames";
import { useState, useMemo, useCallback, useEffect } from "react";
import { Section } from "shared/layout";
import Table from "shared/Table";
import { Auth } from "shared/@auth/Auth";
import TextInput from "shared/@forms/TextInput";
import { useLogger } from "shared/@hooks/useLogger";
import Loader from "shared/Loader";

export default function Billing() {
  const { makeAuthedRequest } = Auth.useContainer();
  const base = `/billing`;

  return (
    <div className={styles.container}>
      <Section>
        <header className={styles.sectionHeader}>
          <h1>Main Billing</h1>
        </header>

        <Step
          number="1"
          badge={stepBadgeTypes.process}
          title="Expire Expired Cards"
          resultsFunc={useCallback(
            () => makeAuthedRequest(`${base}/cards/expire`, { method: "POST" }),
            []
          )}
        />

        <Step
          number="2"
          badge={stepBadgeTypes.check}
          title="Check for Missing Primary Billing"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/missing-primary`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="3"
          badge={stepBadgeTypes.check}
          title="Check for Missing Previous Payment"
          params={{
            month: {
              label: "Month",
              placeholder: "MM",
              initialValue: (new Date().getMonth() + 1).toString(),
            },
            year: {
              label: "Year",
              placeholder: "YYYY",
              initialValue: new Date().getFullYear().toString(),
            },
          }}
          resultsFunc={useCallback(
            ({ month, year }) =>
              makeAuthedRequest(
                `${base}/check/missing-payment?month=${month}&year=${year}`,
                {
                  method: "GET",
                }
              ),
            []
          )}
        />

        <Step
          number="4"
          badge={stepBadgeTypes.check}
          title="Check for Invalid Last Transaction"
          params={{
            month: {
              label: "Month",
              placeholder: "MM",
              initialValue: (new Date().getMonth() + 1).toString(),
            },
            year: {
              label: "Year",
              placeholder: "YYYY",
              initialValue: new Date().getFullYear().toString(),
            },
          }}
          resultsFunc={useCallback(
            ({ month, year }) =>
              makeAuthedRequest(
                `${base}/check/invalid-transaction?month=${month}&year=${year}`,
                {
                  method: "GET",
                }
              ),
            []
          )}
        >
          <Step
            // number="1"
            badge={stepBadgeTypes.process}
            title="Insert No Charge Transaction"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/check/insert-nocharge`, {
                  method: "POST",
                }),
              []
            )}
          />
        </Step>

        <Step
          number="5"
          badge={stepBadgeTypes.check}
          title="Check for Wrong Next Bill Date"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/wrong-billdate`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="6"
          badge={stepBadgeTypes.check}
          title="Check for Pending Membership Transactions"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/pending-transaction/member`, {
                method: "GET",
              }),
            []
          )}
        >
          <Step
            // number="1"
            badge={stepBadgeTypes.check}
            title="Check for Pending Digital Transactions"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/check/pending-transaction/digital`, {
                  method: "GET",
                }),
              []
            )}
          />
          <Step
            // number="1"
            badge={stepBadgeTypes.process}
            title="Cancel Pending Membership Transactions"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/cancel/pending-member`, {
                  method: "POST",
                }),
              []
            )}
          />

          <Step
            // number="2"
            badge={stepBadgeTypes.process}
            title="Cancel Pending Digital Transactions"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/cancel/pending-digital`, {
                  method: "POST",
                }),
              []
            )}
          />
        </Step>

        <Step
          number="7"
          badge={stepBadgeTypes.process}
          title="Expire Memberships"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/expire/membership`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="8"
          badge={stepBadgeTypes.process}
          title="Process Downgrades"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/process/downgrades`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="9"
          badge={stepBadgeTypes.process}
          title="Process Digital Delivery"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/process/delivery`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="10"
          badge={stepBadgeTypes.check}
          title="Check for Basic w/ Digital Delivery"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/basic-delivery`, {
                method: "GET",
              }),
            []
          )}
        >
          <Step
            // number="1"
            badge={stepBadgeTypes.process}
            title="Remove Basic w/ Digital Delivery"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/remove/basic-delivery`, {
                  method: "POST",
                }),
              []
            )}
          />
        </Step>

        <Step
          number="11"
          badge={stepBadgeTypes.check}
          title="Check for non-Delivery"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/non-delivery`, {
                method: "GET",
              }),
            []
          )}
        >
          <Step
            // number="1"
            badge={stepBadgeTypes.process}
            title="Remove non-Delivery"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/remove/non-delivery`, {
                  method: "POST",
                }),
              []
            )}
          />
        </Step>

        <Step
          number="12"
          badge={stepBadgeTypes.process}
          title="Bill for Primary Membership"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/billing/primary-membership`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="13"
          badge={stepBadgeTypes.check}
          title="Check for Transaction Issues"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/transaction-issues`, {
                method: "GET",
              }),
            []
          )}
        >
          <Step
            badge={stepBadgeTypes.process}
            title="Remove Transaction Issues"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/remove/transaction-issues`, {
                  method: "POST",
                }),
              []
            )}
          />
        </Step>

        <Step
          number="14"
          badge={stepBadgeTypes.process}
          title="Bill for Primary Digital"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/billing/primary-digital`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="15"
          badge={stepBadgeTypes.process}
          title="Auto-fix Billing Issues"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/billing/autofix-issues`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="16"
          badge={stepBadgeTypes.check}
          title="Check Balance Zero"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/balance-zero`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="17"
          badge={stepBadgeTypes.check}
          title="Check Type Mismatch"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/type-mismatch`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="18"
          badge={stepBadgeTypes.check}
          title="Check for missing Digital Delivery"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/digital-missing`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="19"
          badge={stepBadgeTypes.check}
          title="Check for Double Billing"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/double-billing`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="20"
          badge={stepBadgeTypes.process}
          title="Insert Member Pending"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/insert/member-pending`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="21"
          badge={stepBadgeTypes.process}
          title="Insert Digital Pending"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/insert/digital-pending`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="22"
          badge={stepBadgeTypes.check}
          title="Check Consolidated"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/consolidated`, {
                method: "GET",
              }),
            []
          )}
        />

        <Step
          number="23"
          badge={stepBadgeTypes.process}
          title="Insert Consolidated"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/insert/consolidated`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="24"
          badge={stepBadgeTypes.process}
          title="Process Transactions"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/billing/process-transactions`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="25"
          badge={stepBadgeTypes.check}
          title="Check Renew Digital"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/renew-digital`, {
                method: "GET",
              }),
            []
          )}
        />
      </Section>

      <Section>
        <header className={styles.sectionHeader}>
          <h1>Billing Retry</h1>
        </header>

        <Step
          number="1"
          badge={stepBadgeTypes.check}
          title="Check Cancel with Digital"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/check/cancel-with-digital`, {
                method: "GET",
              }),
            []
          )}
        >
          <Step
            // number="1"
            badge={stepBadgeTypes.process}
            title="Remove Cancel with Digital"
            resultsFunc={useCallback(
              () =>
                makeAuthedRequest(`${base}/remove/cancel-with-digital`, {
                  method: "POST",
                }),
              []
            )}
          />
        </Step>

        <Step
          number="2"
          badge={stepBadgeTypes.process}
          title="Retry Primary Billing"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/primary/billing-retry`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="3"
          badge={stepBadgeTypes.process}
          title="Expire Suspended Accounts"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/expire/suspense-accounts`, {
                method: "POST",
              }),
            []
          )}
        />

        <Step
          number="4"
          badge={stepBadgeTypes.process}
          title="Retry Digital Delivery Billing"
          resultsFunc={useCallback(
            () =>
              makeAuthedRequest(`${base}/billing/digital-retry`, {
                method: "POST",
              }),
            []
          )}
        />
      </Section>
    </div>
  );
}

const stepBadgeTypes = {
  check: "Check",
  process: "Process",
};

function Step({ number, title, params, badge, resultsFunc, children }) {
  const { logError } = useLogger({ prefix: "BillingStep" });
  const [data, setData] = useState(null);
  const [paramValues, setParamValues] = useState({});
  const [isWaiting, setIsWaiting] = useState(false);

  const run = useCallback(
    (e) => {
      e.preventDefault();
      setIsWaiting(true);

      return resultsFunc(paramValues)
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const body = await res.json();
            throw new Error(body.message);
          }
        })
        .then((res) => {
          setData(res);
        })
        .catch(logError)
        .finally(() => {
          setIsWaiting(false);
        });
    },
    [paramValues, resultsFunc, logError]
  );

  // Set initial param values.
  useEffect(() => {
    if (params == null) {
      setParamValues({});
    } else {
      const _paramValues = {};

      for (const paramName of Object.keys(params)) {
        if ("initialValue" in params[paramName]) {
          _paramValues[paramName] = params[paramName].initialValue;
        }
      }

      setParamValues(_paramValues);
    }
  }, [params]);

  return (
    <div className={styles.step}>
      <NumberSection label={number}>
        <Card>
          <div className={styles.stepHeader}>
            <div>
              {badge && (
                <div className={classNames(styles.stepBadge, styles[badge])}>
                  {badge}
                </div>
              )}
              <h3 className={styles.stepTitle}>{title}</h3>
            </div>

            <form className={styles.stepActions} onSubmit={run}>
              {isWaiting && <Loader size={72} />}

              {params && (
                <div className={styles.stepParams}>
                  {Object.keys(params).map((paramName) => {
                    const options = params[paramName];

                    return (
                      <div className={styles.stepParamGroup}>
                        <label>{options.label}</label>
                        <TextInput
                          value={paramValues[paramName]}
                          required={true}
                          onChange={(e) => {
                            setParamValues({
                              ...paramValues,
                              [paramName]: e.target.value,
                            });
                          }}
                          placeholder={options.placeholder}
                        ></TextInput>
                      </div>
                    );
                  })}
                </div>
              )}

              <Button disabled={isWaiting}>Run Step</Button>
            </form>
          </div>

          {data && (
            <div className={styles.stepResults}>
              <JSONTable data={data} />
            </div>
          )}
        </Card>

        {children && <div className={styles.stepSubs}>{children}</div>}
      </NumberSection>
    </div>
  );
}

/**
 * Renders an array of objects of { "column": "value" }
 */
function JSONTable({ data }) {
  const { headings, rows } = useMemo(() => {
    const _headings = {};

    for (const row of data) {
      for (const key of Object.keys(row)) {
        _headings[key] = true;
      }
    }

    const headings = Object.keys(_headings);
    const rows = [];

    for (const row of data) {
      const _row = [];

      for (const key of headings) {
        _row.push(row[key]);
      }

      rows.push(_row);
    }

    return {
      headings,
      rows,
    };
  }, [data]);

  return (
    <>
      <div className={styles.tableInfo}>
        <span>Found {rows.length} records</span>
      </div>
      <Table maxHeight={600}>
        <thead>
          <tr>
            {headings.map((headingText) => (
              <th>{headingText}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr>
              {row.map((columnValue) => (
                <td>{columnValue}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}

function NumberSection({ label, disabled, children }) {
  return (
    <section
      className={classNames(styles.numberSection, {
        [styles.sectionDisabled]: disabled,
      })}
    >
      {label && (
        <div className={styles.numberLabel}>
          <span className={styles.numberLabelText}>{label}</span>
          <div className={styles.numberLabelLine} />
        </div>
      )}
      <div className={styles.numberContent}>{children}</div>
    </section>
  );
}
